import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=37ac9aac&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=37ac9aac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ac9aac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37ac9aac')) {
      api.createRecord('37ac9aac', component.options)
    } else {
      api.reload('37ac9aac', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=37ac9aac&scoped=true&", function () {
      api.rerender('37ac9aac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iGDHaPYP8nGo/JS/comp/PopupBox.vue"
export default component.exports